var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconDebitCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.717 3.646A2.725 2.725 0 000 6.363V18.32a2.725 2.725 0 002.717 2.717h19.566A2.725 2.725 0 0025 18.32V6.363a2.725 2.725 0 00-2.717-2.717H2.717zm0 1.087h19.566c.906 0 1.63.724 1.63 1.63V7.45H1.087V6.363c0-.906.724-1.63 1.63-1.63zm-1.63 5.435h22.826v8.152c0 .906-.724 1.63-1.63 1.63H2.717c-.906 0-1.63-.724-1.63-1.63v-8.152z",
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
}

export default SvgCommonIconDebitCard;